import(/* webpackMode: "eager", webpackExports: ["default"] */ "/site-builder-src/node_modules/.pnpm/next-intl@4.1.0_next@15.3.6_@babel+core@7.29.7_@opentelemetry+api@1.9.1_react-dom@19.2.1_reac_em32sbjymeocpdskirekiqu2au/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/site-builder-src/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutRender"] */ "/site-builder-src/src/components/layout-render/layout-render.tsx");
